import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography } from "@mui/material";

// INITIAL FORM DATA - Default values for creating a new finance
export const financeInitialData = {
  // Add fields when Finance model is finalized
};

// FORM VALIDATION
export function validateFinance(data) {
  const errors = {};
  // Add validation rules here as form is implemented
  return errors;
}

// NULLABLE FIELDS - Fields that should be converted from empty string to null
export const financeNullableFields = [
  // Add nullable fields here as form is implemented
];

const FinanceFormFields = ({ data, editable, onChange, errors = {} }) => {
  return (
    <Box component="form" sx={{ mt: 2, mb: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              Coming Soon
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Finance fields will be implemented here.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

FinanceFormFields.propTypes = {
  data: PropTypes.object.isRequired,
  editable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export default FinanceFormFields;
